<template>
    <div class="p-4 relative">
        <div @click="removeCartItem(item.product_id)" class="absolute top-4 right-4 cursor-pointer">
            <Icon icon="fal fa-times"></Icon>
        </div>
        <div class="">
            <div class="">
                <div v-if="isValid.isValid===false"
                     class="absolute bg-white text-sm bg-opacity-80 top-4 left-4 border border-sn-dark-red rounded-xl p-3 flex justify-center items-center"
                >
                    <div class="w-full">
                        <h4>Product Unavailable</h4>
                        <span>{{ isValid.invalidMessage }}</span>
                    </div>
                </div>
                <div class="">
                    <div class="flex flex-col gap-6">
                        <div class="flex items-center">
                            <ApiImage class="w-24 flex-shrink-0" :src="item.product?.main_image?.url ?? ''" />
                            <div class="pl-4">
                                <div class="flex items-center justify-start mb-1">
                                    <span v-if="item.product?.is_variant" class="px-2 inline-block py-1 bg-sn-superlight-blue border border-sn-light-blue rounded-xl text-xs">Variant</span>
<!--                                    <span v-if="item.product?.is_mtm_extra" class="px-2 inline-block py-1 bg-sn-superlight-blue border border-sn-light-blue rounded-xl text-xs">Extra</span>-->
                                </div>
                                <h3 class="text-xl" v-text="item.product?.name"></h3>
                                <div class="flex flex-wrap items-center gap-1.5 mt-2">
                                    <template
                                        v-for="(attribute, attributeCode) in getProductAttributesByFilter({is_gui_listing: true}, item.product)"
                                    >
                                        <AttributeLoader
                                            :attribute="getAttribute(attributeCode)"
                                            :attribute-value="attribute"
                                            :badge="true"
                                        />
                                    </template>
                                </div>
<!--                                <div class="absolute top-5 left-5" v-if="parsedFlags || product.supply_route_id">-->
<!--                                    <template v-for="(flag, index) in parsedFlags">-->
<!--                                        <Action-->
<!--                                            v-if="flag !== null && typeof flag.icon !== 'undefined'"-->
<!--                                            class="flag"-->
<!--                                            :style="'font-weight:600;color:' + (typeof flag.color === 'undefined' ? 'rgba(0,0,0,0.2)' : flag.color)"-->
<!--                                            :tooltip="flag.tooltip"-->
<!--                                            :icon="flag.icon">-->
<!--                                        </Action>-->
<!--                                    </template>-->
<!--&lt;!&ndash;                                    <product-supply-route v-if="typeof productSupplyRoute !== 'undefined'"&ndash;&gt;-->
<!--&lt;!&ndash;                                                          :supply-route="productSupplyRoute"&ndash;&gt;-->
<!--&lt;!&ndash;                                                          :key="`product-${product.id}-supply-route`"&ndash;&gt;-->
<!--&lt;!&ndash;                                    />&ndash;&gt;-->
<!--                                </div>-->
                            </div>
                        </div>
<!--                        <div>-->
<!--                            <ProductStock-->
<!--                                :supply-route="product.supply_route ?? {}"-->
<!--                                :product-stock="product.stock"-->
<!--                            />-->
<!--                        </div>-->

                        <div class="flex items-center justify-between flex-shrink-0">

<!--                            <ProductAddToBasket-->
<!--                                class="flex flex-col items-center"-->
<!--                                :product="item.product"-->
<!--                                :product-stock="product.stock"-->
<!--                                :supply-route="product.supply_route ?? {}"-->
<!--                                :price-attributes="attributes.filter((a) => a.type === 'price')"-->
<!--                                :single-gross-price="product.price?.price_gross"-->
<!--                                :cart-items="[]"-->
<!--                            />-->

                            <ProductQuantity
                                :quantity="productQuantity"
                                :allow-input="true"
                                @updateQuantity="updateProductQuantity"
                            />

                            <div class="total">
                                {{ formatPrice(productQuantity * Number(item.unit_price_gross)) }}
                                <small v-if="productQuantity > 1">({{ formatPrice(Number(item.unit_price_gross)) }} each)</small>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script setup lang="ts">

import ApiImage from "@/components/core/ApiImage.vue";
import {useAttributes} from "@/composables/useAttributes";
import AttributeLoader from "@/components/orderProcess/AttributeLoader.vue";
import type {CartItemData} from "@/types/ecommerce";
import ProductQuantity from "@/components/orderProcess/ProductQuantity.vue";
import {formatPrice} from "@/composables/usePrice";
import Icon from "@/components/core/Icon.vue";
import {useCart} from "@/composables/useCart";

const { attributes, fetchAttributes, getAttribute, getProductAttributesByFilter } = await useAttributes();
const { removeCartItem } = await useCart();

const props = defineProps({
    item: {
        type: Object as PropType<CartItemData>,
        required: true,
    },
    isValid: {
        type: Object,
        default: { isValid: true },
    },
    showSingle: {
        type: Boolean,
        default: false,
    }
});

const productQuantity = defineModel();

function updateProductQuantity(quantity: number){
    productQuantity.value = quantity;
}

</script>